export enum CleverTapEventsCardOnFile {
  // Add/Create Card on File Events
  webCOFAddCardClicked = 'Web_COF_Add_Card_Clicked',
  webCOFAddCardModalOpen = 'Web_COF_Add_Card_Modal_Open',
  webCOFAddCardSuccess = 'Web_COF_Add_Card_Success',
  webCOFAddCardFailed = 'Web_COF_Add_Card_Failed',
  webCOFAddCardStripeFailed = 'Web_COF_Add_Card_Stripe_Failed',

  // Delete Card on File Events
  webCOFDeleteCardClicked = 'Web_COF_Delete_Card_Clicked',
  webCOFDeleteCardSuccess = 'Web_COF_Delete_Card_Success',
  webCOFDeleteCardFailed = 'Web_COF_Delete_Card_Failed',
  webCOFDeleteCardCancelled = 'Web_COF_Delete_Card_Cancelled',

  // Edit/Manage Card on File Events
  webCOFManageCardModalOpen = 'Web_COF_Manage_Card_Modal_Open',
  webCOFEditCardClicked = 'Web_COF_Edit_Card_Clicked',
  webCOFEditCardSuccess = 'Web_COF_Edit_Card_Success',

  // Pay with Card on File Events
  webCOFChargeCardModalOpen = 'Web_COF_Charge_Card_Modal_Open',
  webCOFChargeCardInitiated = 'Web_COF_Charge_Card_Initiated',
  webCOFChargeCardSuccess = 'Web_COF_Charge_Card_Success',
  webCOFChargeCardFailed = 'Web_COF_Charge_Card_Failed',
  webCOFChargeCardStripeFailed = 'Web_COF_Charge_Card_Stripe_Failed'
}
